<template>
  <!-- 退費政策視窗 -->
  <ui-modal
    ref="cancellationPolicyModal"
    content-class="cancellation-policy-dialog"
    :forcing="true"
    :header-title="headerTitle"
    :hide-overlay="false"
  >
    <v-sheet class="cancellation-policy-container" min-height="142" max-height="60vh">
      <template v-if="!isDelivery && rulesPayloads.length">
        <div v-for="(payload, index) in rulesPayloads" :key="payload.label">
          <div class="wd-mb-3" :class="index ? 'wd-mt-5' : ''">{{ $t(payload.label) }}</div>
          <ul>
            <li v-for="rule in payload.rules" :key="rule" class="wd-whitespace-pre-line wd-pb-2">
              <span class="pl-0">{{ rule }}</span>
            </li>
          </ul>
        </div>
      </template>
      <p v-else class="wd-whitespace-pre-line">{{ policyText }}</p>
    </v-sheet>
  </ui-modal>
</template>

<script>
import { templateRef } from '@vueuse/core'
import UiModal from '@/components/dialog/ui-modal.vue'
import { useMutationPolicies } from '~/composition/useMutationPolicy'

export default defineComponent({
  name: 'CancellationPolicyModal',
  components: {
    UiModal,
  },
  props: {
    isDelivery: { type: Boolean, default: false },
    isMovie: { type: Boolean, default: false },
    cancelRules: { type: Array, default: () => [] },
    rescheduleRules: { type: Array, default: () => [] },
  },
  setup(props) {
    const cancellationPolicyModal = templateRef('cancellationPolicyModal')
    const { isDelivery, isMovie, cancelRules, rescheduleRules } = toRefs(
      reactive({
        isDelivery: computed(() => props.isDelivery),
        isMovie: computed(() => props.isMovie),
        cancelRules: computed(() => props.cancelRules),
        rescheduleRules: computed(() => props.rescheduleRules),
      })
    )
    const { policyTitle: headerTitle, policyText, rulesPayloads } = useMutationPolicies({ isDelivery, isMovie, cancelRules, rescheduleRules })

    /** parent 會 call 這 fn... */
    function showModal() {
      cancellationPolicyModal.value.showModal()
    }

    /** parent 會 call 這 fn... */
    function hideModal() {
      cancellationPolicyModal.value.hideModal()
    }

    return {
      headerTitle,
      rulesPayloads,
      policyText,
      showModal,
      hideModal,
    }
  },
})
</script>

<style scoped lang="scss">
.cancellation-policy-container {
  padding: 12px 20px 24px;
  overflow-y: auto;
}
</style>
